const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.608,
    height: 14.045,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.783 16.727a.46.46 0 0 1-.212 0 .472.472 0 0 1-.236-.483v-2.357a3.442 3.442 0 0 1-2.982-3.395V6.613a3.43 3.43 0 0 1 3.43-3.418h6.247a3.43 3.43 0 0 1 3.43 3.418v3.878a3.43 3.43 0 0 1-3.43 3.418h-2.581l-3.36 2.711a.507.507 0 0 1-.306.107zm-.036-12.66a2.523 2.523 0 0 0-2.534 2.546v3.878a2.523 2.523 0 0 0 2.534 2.523.448.448 0 0 1 .448.448V15.4L10 13.132a.507.507 0 0 1 .318-.118h2.676a2.523 2.523 0 0 0 2.534-2.523V6.613a2.523 2.523 0 0 0-2.534-2.546z",
    transform: "translate(-3.103 -2.945)",
    style: {
      fill: "#185edf",
      stroke: "#185edf",
      strokeWidth: ".5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentBlue);
export default __webpack_public_path__ + "static/media/commentBlue.15410a324d157395e75371cd304738da.svg";
export { ForwardRef as ReactComponent };